import { render, staticRenderFns } from "./PersonTrainingRecord.vue?vue&type=template&id=3dc9d40e"
import script from "./PersonTrainingRecord.vue?vue&type=script&lang=js"
export * from "./PersonTrainingRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports